import { render } from "./IndexReviewCarousel.vue?vue&type=template&id=e9d916d6"
import script from "./IndexReviewCarousel.vue?vue&type=script&lang=js"
export * from "./IndexReviewCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__